import { string, arrayOf, shape, number } from 'prop-types';

/**
 * @typedef {Object} Value
 * @property {string} id - The ID of the value.
 * @property {string} name - The name of the value.
 * @property {string} url - The URL of the value.
 */

/**
 * @typedef {Object} VehicleBodySelectorProps
 * @property {string} [image] - The image URL for the vehicle body item.
 * @property {Value[]} [values] - Array of vehicle body values.
 * @property {Object} [modal] - Modal configuration object.
 * @property {number} [total_body_types] - Total number of body types available.
 */

export const vehicleBodySelectorPropTypes = {
  image: string.isRequired,
  modal: shape({}).isRequired,
  total_body_types: number.isRequired,
  values: arrayOf(
    shape({
      id: string.isRequired,
      name: string.isRequired,
      url: string.isRequired,
    }).isRequired,
  ).isRequired,
};
